module.exports = __webpack_public_path__ + "img/W-17.2fd26a2f.jpg";